import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FooterComponent } from './components/footer/footer.component';
import { HeroComponent } from './components/hero/hero.component';
import { HeroBodyComponent } from './components/hero/hero-body/hero-body.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { RoomInfoComponent } from './components/room-info/room-info.component';
import { ConferenceInfoComponent } from './components/conference-info/conference-info.component';
import { PipesModule } from '../core/pipes/pipes.module';
import { PageLoadingComponent } from './components/page-loading/page-loading.component';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
    declarations: [
        HeroComponent,
        HeroBodyComponent,
        FooterComponent,
        RoomInfoComponent,
        ConferenceInfoComponent,
        PageLoadingComponent
    ],
    imports: [
        BrowserModule,
        AngularFontAwesomeModule,
        RouterModule,
        LoadingBarHttpClientModule,
        PipesModule,
        MatProgressSpinnerModule
    ],
    exports: [
        HeroComponent,
        HeroBodyComponent,
        FooterComponent,
        RoomInfoComponent,
        ConferenceInfoComponent,
        PageLoadingComponent
    ]
  })
  export class UiGeneralModule { }



// WEBPACK FOOTER //
// ./src/app/ui-general/ui-general.module.ts